"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var Typography_1 = require("../Typography");
var HeadingGroup = function (_a) {
    var overline = _a.overline, heading = _a.heading, body = _a.body, _b = _a.size, size = _b === void 0 ? 'sm' : _b, _c = _a.bodySize, bodySize = _c === void 0 ? 'sm' : _c, _d = _a.align, align = _d === void 0 ? 'left' : _d, containerClassName = _a.containerClassName, headingClassName = _a.headingClassName, overlineClassName = _a.overlineClassName, bodyClassName = _a.bodyClassName;
    var additionalText = null;
    if (body) {
        additionalText = Array.isArray(body) ? body : [body];
    }
    return !heading && !additionalText && !overline ? null : ((0, jsx_runtime_1.jsxs)("header", __assign({ className: (0, classnames_1.default)("\n    squid-flex\n    squid-flex-col\n    squid-gap-alias-space-title-with-text-lg\n    ", {
            'squid-text-left': align === 'left',
            'squid-items-start': align === 'left',
            'squid-text-center': align === 'center',
            'squid-items-center': align === 'center',
            'squid-text-right': align === 'right',
            'squid-items-end': align === 'right',
        }, containerClassName) }, { children: [overline && ((0, jsx_runtime_1.jsx)(Typography_1.Overline, __assign({ as: "h6", color: "info", className: (0, classnames_1.default)('squid-uppercase', overlineClassName) }, { children: overline }))), (0, jsx_runtime_1.jsx)(Typography_1.Heading, __assign({ as: "h3", variant: size, color: "base", className: headingClassName }, { children: heading })), additionalText === null || additionalText === void 0 ? void 0 : additionalText.map(function (text, index) { return ((0, jsx_runtime_1.jsx)(Typography_1.Body, __assign({ as: "h6", size: (bodySize !== null && bodySize !== void 0 ? bodySize : size === 'sm') ? 'sm' : 'lg', color: "weaker", className: (0, classnames_1.default)('squid-mb-1', bodyClassName) }, { children: text }), "".concat(text, "_").concat(index))); })] })));
};
exports.HeadingGroup = HeadingGroup;
